import { PreparedQueryMode, PreparedQuerySimple } from '@aipb/gulliver/catalog/env';
import { PreparedQueryModel } from '@aipb/gulliver/catalog/model';

import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { NgxMasonryModule } from 'ngx-masonry';
import { NgxMasonryOptions } from 'ngx-masonry/lib/ngx-masonry-options';
import { PermissionUseCase } from '../../usecases';
import { DashboardCardItemComponent } from '../dashboard-card-item/dashboard-card-item.component';
import { DashboardSimpleCardItemComponent } from '../dashboard-simple-card-item/dashboard-simple-card-item.component';

@Component({
  selector: 'cat-dashboard-card-list',
  templateUrl: './dashboard-card-list.component.html',
  styleUrls: ['./dashboard-card-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgxMasonryModule, DashboardCardItemComponent, DashboardSimpleCardItemComponent]
})
export class DashboardCardListComponent {
  @Input() items: PreparedQueryModel[] = [];
  @Input() mode: PreparedQueryMode;
  @Input() simpleSettings: PreparedQuerySimple;
  @Output() search = new EventEmitter<PreparedQueryModel>();

  masonryOptions: NgxMasonryOptions = {
    itemSelector: '.masonry-item',
    columnWidth: '.grid-sizer',
    horizontalOrder: true,
    percentPosition: true
  };

  private permission = inject(PermissionUseCase);

  hasPermission(query: PreparedQueryModel) {
    return this.permission.execute(query);
  }
}
